// extracted by mini-css-extract-plugin
export default {"activeLink":"MainLayout_activeLink__qJWgG","link":"MainLayout_link__qY1wW","active":"MainLayout_active__7DZ7U"};